import React, { Component } from "react";

interface IframeworkStreakEffectContainer {
    data: {}
}
export const frameworkStreakEffectContainer: IframeworkStreakEffectContainer = {
    data: {
        "COMPONENTS": [
            
         
        ],
    }


};

export const StreakEffectContainerConfigurationContext = React.createContext(
    {}
);